import ClientUsersRequests from '../../server/clientUsers';
import { addLoading, removeLoading } from './loading';


export const uploadClientUsers = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ClientUsersRequests.uploadCsvClientUsers(file);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvClientUserModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ClientUsersRequests.getCsvClientUserModel();
  } finally {
    dispatch(removeLoading());
  }
};

export default {
  uploadClientUsers,
  getCsvClientUserModel,
};
